import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useFetchActivityTypes, useFetchUser } from "@anefi/services";
import { convertDataToDataSelect } from "@anefi/utils";

import Styles from "./StepSevenForm.styles";
import { StepSevenFormProps as Props } from "./StepSevenForm.types";
import { StepSevenFormValues } from "./StepSevenForm.types";
import useI18n from "hooks/useI18n";
import FormDropdown from "components/global/FormDropdown/FormDropdown";
import NumberInput from "components/global/NumberInput/NumberInput";
import useAuth from "contexts/auth/auth.context.hooks";

const StepSevenForm: React.FC<Props> = props => {
  const t = useI18n();
  const { formState, control } = useFormContext<StepSevenFormValues>();
  const { data: activityTypesData } = useFetchActivityTypes();
  const auth = useAuth();
  const { data: user } = useFetchUser(auth);
  const { additionalInfo } = user ?? {};
  const { businessActivityTypeCode } = additionalInfo ?? {};

  const activityTypesForSelect = useMemo(
    () => convertDataToDataSelect(activityTypesData, "code", "name"),
    [activityTypesData]
  );
  const defaultActivityType = useMemo(() => {
    return activityTypesForSelect.filter(
      activityTypes => activityTypes.key === businessActivityTypeCode
    )[0];
  }, [activityTypesForSelect, businessActivityTypeCode]);

  const errors = formState?.errors ?? {};
  const { businessActivityTypeCode: businessActivityError } = errors;

  return (
    <Styles className="StepSevenForm">
      <p className="StepSevenForm__title">{t.stepSevenForm.title}</p>
      <Controller
        name="businessActivityTypeCode"
        control={control}
        render={({ field }) => (
          <FormDropdown
            {...field}
            className="StepSevenForm__select"
            selectData={activityTypesForSelect}
            label={t.stepSevenForm.businessActivityTypeCode}
            errorMessage={businessActivityError?.message}
            defaultValue={businessActivityTypeCode}
            defaultOption={defaultActivityType?.value}
            onChange={e => {
              field.onChange(e);
            }}
            placeholder={t.stepSevenForm.businessActivityTypeCode}
          />
        )}
      />
      <NumberInput
        name="totalIncome"
        control={control}
        label={t.stepSevenForm.totalIncome}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="monthlyExpenses"
        control={control}
        label={t.stepSevenForm.monthlyExpenses}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalAssets"
        control={control}
        label={t.stepSevenForm.totalAssets}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalLiabilities"
        control={control}
        label={t.stepSevenForm.totalLiabilities}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalHeritage"
        control={control}
        label={t.stepSevenForm.totalEquity}
        placeholder="0.00"
        maxLength={10}
      />
    </Styles>
  );
};

StepSevenForm.defaultProps = {};

export default StepSevenForm;
